import qs from "qs";
import {AxiosResponse} from "axios";
import request from "./base.service";
import {removeToken} from "../helper/helper";

import {IApiResponseCaptcha} from "../models/service.model";
import {ILogin} from "../models/auth.model";
import {IResponseCaptcha} from "../models/captcha.model";

function captcha(): Promise<IApiResponseCaptcha<IResponseCaptcha>> {
  return request.build().post(`/public/v1/fs/captcha`);
}

function login(data: any): Promise<AxiosResponse<any>> {
  return request
    .withHeaders({'Content-Type': 'application/json;utf-8'})
    .build().post(`/public/v1/fs/users/registration/init?lang=fa`, data);
}

function loginFinalize(dataFinilize: any): Promise<AxiosResponse<any>> {
  return request
    .withHeaders({'Content-Type': 'application/json;utf-8'})
    .build()
    .post(`/public/v1/fs/users/registration/finalize?lang=fa`, dataFinilize);
}

function loginWithSSO(data: any): Promise<AxiosResponse<any>> {
  return request
    .withHeaders({'Content-Type': 'application/json;utf-8'})
    .build()
    .post(`/public/v1/fs/users/registration/sso/my-gov?lang=fa`, data);
}

const logout: () => void = () => {
  try {
    removeToken();
  } catch (e: any) {
    // console.log(e);
    window.location.href = "/";
  } finally {
    window.location.href = "/";
  }
};

function token(params: any): Promise<AxiosResponse<ILogin>> {
  return request
    .withHeaders({"Content-Type": "application/x-www-form-urlencoded;utf-8"})
    .build()
    .post(`/oauth/token?lang=fa`, qs.stringify(params));
}


// eslint-disable-next-line
export default {
  captcha,
  login,
  loginFinalize,
  logout,
  token,
  loginWithSSO
};
